import React from "react";
import {
  Calendar,
  Bell,
  Robot,
  Sparkle,
  UsersThree,
  Receipt,
  Files,
  ChartLineUp,
  ShieldCheck,
} from "@phosphor-icons/react";
import useStartReveal from "../start/useStartReveal";
import "./ForPage.css";

const ICONS = { Calendar, Bell, Robot, Sparkle, UsersThree, Receipt, Files, ChartLineUp, ShieldCheck };
const CYCLE = ["Calendar", "Bell", "Robot", "Sparkle"];

/**
 * Icon-card grid (st-sec-card anatomy). `items`: [{ icon?, title, desc }].
 * Items without an icon cycle through calendar / bell / AI / sparkle.
 */
export default function ForFeatures({ id = "for-features", overline, title, sub, intro, items = [], alt = true }) {
  const ref = useStartReveal();
  if (items.length === 0) return null;

  return (
    <section id={id} className={`st-section fr-feats${alt ? " st-section--alt" : ""}`} aria-labelledby={`${id}-title`}>
      <div className="st-container st-reveal" ref={ref}>
        {overline && <p className="st-overline st-center">{overline}</p>}
        <h2 id={`${id}-title`} className="st-h2 st-center">{title}</h2>
        {sub && <p className="st-sub st-center fr-section-sub">{sub}</p>}
        {intro && <p className="fr-intro">{intro}</p>}
        <div className="fr-feats-grid">
          {items.map((f, i) => {
            const Icon = ICONS[f.icon] || ICONS[CYCLE[i % CYCLE.length]];
            return (
              <article key={f.title} className="fr-feat">
                <span className="fr-feat-icon" aria-hidden="true">
                  <Icon size={22} weight="fill" />
                </span>
                <h3 className="fr-feat-title">{f.title}</h3>
                <p className="fr-feat-desc">{f.desc}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
